<template>
    <pop class="pop-prize" :show="show" @close="handleClose" :contentIsScroll="false">
        <div class="prize-swiper-wrapper" v-stop-native-touch="200">
            <Swiper :options="swiperOptions">
                <SwiperSlide class="prize-item" v-stop-native-touch="200" v-for="(prizeItem, index) in prizeList" :key="`prizeItem-${prizeItem.key || prizeItem.id}-${index}`">
                    <div class="prize-item-content">
                        <template v-if="prizeItem.type == 2">
                            <div class="title-vote"></div>
                            <img class="prize-item-token" src="@/assets/images/pop/img_token.png" alt="">
                            <Stepper class="prize-item-stepper" :min="1" :max="+store.pageData?.vote_num || 1" v-model="value" />
                        </template>
                        <template v-else>
                            <div :class="[prizeItem.status == 1 ? 'title-congratulations' : 'title-weihuode']"></div>
                            <div class="prize-wrapper">
                                <p class="prize-avatar-bg"></p>
                                <img class="prize-item-avatar" :src="prizeItem.img_url" alt="">
                            </div>
                            <p class="prize-item-avatar-name">{{ prizeItem.title || '番外许愿头像框' }}</p>
                        </template>
                        <span class="flex-1"></span>
                        <div class="bottom-btn" @click="handleBottomBtnClick(prizeItem)">{{ prizeItem.type == 2 ? '立即投票' : prizeItem.status == 1 ? '前往佩戴' : store.pageData?.can_vote ? '前往投票' : '投票已结束' }}</div>
                    </div>

                </SwiperSlide>
            </Swiper>
            <div class="prize-swiper-pagination" v-show="prizeList.length > 1"></div>
        </div>
    </pop>
</template>
<script lang="ts" setup>
import { ref, onMounted, computed, watch } from 'vue';
import { QPop } from '@q-front-npm/h5-ui';
import SwiperCore, { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/components/pagination/pagination.scss';
import pop from '@common/components/pop.vue';

SwiperCore.use([Pagination]);
import { useStore } from '../store';
import { schemaSingle, openWebview, jsbTouchEvent } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@common/store/common';
import { usePopScale } from '@common/hooks/usePopScale';
import { apiVote } from '../http/api';
import { handleLogin } from '@common/assets/ts/utils';
import { isSupport, nativeTo, SchemaMap, schemaSupportMap, openFlutterPage } from '@q-front-npm/jsbridge';
import Vue from 'vue';

import { Stepper } from 'vant';
import 'vant/lib/stepper/style/index.js';

const store = useStore();
const storeCommon = useStoreCommon();

const emit = defineEmits(['update:show', 'close', 'btnClick', 'showAvatarPop', 'refresh']);

// 是否显示
const show = ref(false);

// 监听store.prizePopData.show
watch(() => store.prizePopData.show, (newVal) => {
    if (newVal) value.value = 1;
    show.value = newVal;
});
const prizeList = computed(() => store.prizePopData.data);
const value = ref(1);
const handleClose = () => {
    jsbTouchEvent(false);
    // show.value = false;
    store.setPrizePopData({
        show: false,
    });
};

// 是否展示去更换按钮
const geShowChangeBtn = (item: any) => {
    // 阅读背景不展示去更换按钮
    if (item.reward_type == '104') return false;
    // 马年限定头像鸿蒙不展示去更换按钮
    if (storeCommon.systemInfo.isHarmony && item.reward_type == '105') return false;
    return true;
};
// // 奖励详情
// const prizeItem = ref({});

const swiperOptions = ref({
    direction: 'horizontal',
    loop: false,
    allowTouchMove: prizeList.value.length > 1,
    autoplay: false,

    autoHeight: true, //高度随内容变化
    pagination: {
        el: '.prize-swiper-pagination',
        clickable: false,
    },
    on: {
        slideChange: function(this: any) {
            // this 指向 swiper 实例，可以通过 activeIndex 获取当前 slide 索引
            // if (!isShow.value.includes(this.activeIndex)) {
            //     report(this.activeIndex);
            // }
        },
    },
});
watch(() => show.value, (newVal) => {
    if (newVal && prizeList.value.length > 1) {
        swiperOptions.value.allowTouchMove = prizeList.value.length > 1;
    }
});

// 头像挂件
const handleWearAvatar = async(item: any) => {
    openWebview(`https://xiaoshuo.wtzw.com/app-h5/freebook/avatar-pendant`);
};

// 更换头像页面
const changeAvatarPage = () => {
    nativeTo(SchemaMap.settingAvatar);
};

// 勋章页面
const medalPage = () => {
    if (!schemaSupportMap.medal_center) return Vue.prototype.$toast('勋章功能已上线，请更新最新版本');
    openFlutterPage('medal_center');
};

// TODO 跳转电子签名 签名卡id
const jumpElectronicSignature = (item: any) => {
    // if (storeCommon.systemInfo.isHarmony) return Vue.prototype.$toast('功能开发中，敬请期待～');
    openWebview(`https://xiaoshuo.wtzw.com/h5/activity/freereaderSignatureCard/detail?full_screen=3&cid=${item?.id || ''}`);
};

// 处理跳转
const handleJump = (item: any) => {
    if (!handleLogin(storeCommon.userInfo.user_type)) return;
    // 未完成任务不跳转
    if (item.status == '0') return;

    const { reward_type, } = item;
    const rewardTypeMap = {
        '102': handleWearAvatar,
        '105': changeAvatarPage,
        '106': medalPage,
        '108': jumpElectronicSignature,
    };
    // 如果下发了btn_url，则直接跳转
    if (item.btn_url) {
        schemaSingle.openSchema(item.btn_url);
        return;
    }
    rewardTypeMap?.[reward_type]?.(item);
};

const handleBottomBtnClick = async(item: any) => {
    if (item.type == 2) {
        const res = await apiVote({
            book_id: item.book_id,
            count: value.value,
        });
        if (res.errors) return Vue.prototype.$toast(res.errors.msg);
        Vue.prototype.$toast('投票成功');
        emit('refresh', {book_id: item.book_id, count: value.value,});
        // 是否需要自动弹窗奖励
        if (res?.complete_task?.length > 0) {
            setTimeout(() => {
                console.log('res.complete_task', res.complete_task);
                let pop: any[] = [];
                if (res.complete_task.includes('vote_1')) {
                    pop = [{
                        type: 1,
                        ...store.pageData?.vote_task_info?.[0],
                        img_url: store.prizeImg[0],
                    }];
                }
                if (res.complete_task.includes('vote_50')) {
                    pop = [{
                        type: 1,
                        ...store.pageData?.vote_task_info?.[1],
                        img_url: store.prizeImg[1],
                    }];
                }
                console.log('pop', pop);
                if (pop.length > 0) {
                    store.setPrizePopData({
                        show: true,
                        data: pop,
                    });
                }
            }, 800);
        }
    } else {
        if (item.status != 1) {
            // store.pageData?.can_vote ? Vue.prototype.$toast('赶紧去参与投票吧～') : Vue.prototype.$toast('暂未获得');
            handleClose();
            return;
        }
        openWebview(`https://xiaoshuo.wtzw.com/app-h5/freebook/avatar-pendant`);
        // handleJump(item);
    }
    handleClose();
};

// 缩放，书城页展示高度不够的时候使用
// const { className, } = usePopScale(720);
</script>

<style lang="scss" scoped>
.prize-swiper-wrapper {
    position: relative;
}
.prize-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 496px!important;
    height: 630px;
    margin: 0 auto;
}
.prize-item-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 80px;
}
.prize-item-token {
    width: 188px;
    margin-top: 22px;
}
.title-congratulations, .title-vote, .title-weihuode {
    margin-top: 74px;
}
::v-deep .prize-swiper-pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;
    width: 100%;
    background: transparent;
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 8px;
        background: rgba(204,204,204,1);
        &:last-child {
            margin-right: 0px;
        }
        &-active {
            background: #FCC800;
        }
    }
}
.bottom-btn {
    width: 300px;
    height: 86px;
    background: url('@/assets/images/pop/pop_img_btn.png') no-repeat center center / 100% 100%;
    line-height: 86px;
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    color: #7B1111;
}
.flex-1 {
    flex: 1;
}
.prize-wrapper {
    position: relative;
    width: 180px;
    height: 180px;
    margin-top: 34px;
}
.prize-avatar-bg {
    width: 160px;
    height: 160px;
    background: #FFF4C1;
    opacity: 0.9;
    filter: blur(20px);
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: -1;
}
.prize-item-avatar {
    position: absolute;
    top: 0;
    left: 0;
    height: 180px;
    z-index: 1;
}
.prize-item-avatar-name {
    font-weight: bold;
    font-size: 26px;
    color: #FFF7E3;
    line-height: 36px;
    margin-top: 12px;
}
</style>
<style lang="scss">
.prize-item-stepper {
    margin-top: 16px;
    background: #FFF8C4;
    border-radius: 8px;
    .van-stepper__minus, .van-stepper__plus {
        width: 44px;
        height: 44px;
        background: #FFEC29;
        border-radius: 8px;
        font-weight: bolder;
        font-size: 28px;
    }
    .van-stepper__minus--disabled, .van-stepper__plus--disabled {
        background: #FFEC29;
        border: 0.5px solid #6A5B00;
        opacity: 0.3;
    }
    .van-stepper__minus--disabled::after, .van-stepper__plus--disabled::before, .van-stepper__plus--disabled::after, .van-stepper__minus--disabled::before {
        background-color: #6A5B00!important;
    }
    .van-stepper__minus::after, .van-stepper__minus::before, .van-stepper__plus::after, .van-stepper__plus::before {
        background-color: #222!important;
    }
    .van-stepper__plus::after {
        width: 3px;
        border-radius: 3px;
    }
    .van-stepper__plus::before {
        height: 3px;
        border-radius: 3px;
    }
    .van-stepper__minus::before {
        height: 3px;
        border-radius: 3px;
    }
    .van-stepper__input {
        width: 72px;
        height: 44px;
        font-weight: bold;
        font-size: 28px;
        color: #111111;
        background: #FFF8C4;
    }
}
.pop-prize {
    .pop-content-wrapper {
        position: relative;
    }
}
</style>
